import { dom } from '../../dom'


export const focus = {
  mounted: (el) => el.focus()
}

const ToolTips = new WeakMap()

export const tooltip = {
  mounted(el, binding) {
    const docBody = document.body
    let tooltip = document.createElement('div')
    let text = document.createTextNode(binding.value)
    let svg = `<svg width="66" height="62" style="position: absolute; left: 50%; bottom: -43px; transform:translateX(-50%)"><path  d="M33 25L28 19H38L33 25Z" fill="var(--tooltip--bg)"/><svg>`
    tooltip.innerHTML = svg
    tooltip.appendChild(text)
    tooltip.classList.add('eui-tooltip')

    ToolTips.set(el, tooltip)

    el.onmouseover = function () {
      let { left, top, width } = el.getBoundingClientRect()
      docBody.appendChild(tooltip)

      let x = `${left + width / 2 - tooltip.clientWidth / 2}px`
      let y = `${top - 32}px`

      dom.create(tooltip).setStyles({
        left: x,
        top: y,
      })
    }

    el.onmouseout = function () {
      docBody.removeChild(tooltip)
    }
  },
  unmounted(el) {
    const tooltip = ToolTips.get(el)
    tooltip && tooltip.remove()
  }

}